import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Output() toggleSideBarForMe: EventEmitter<any> = new EventEmitter();

  origin: string = 'empreenderdinheiro';

  urls = {
    empreenderdinheiro: environment.url.replace('api.', 'investidor.'),
    techfinance: environment.url.replace('api.', 'app.'),
  };

  constructor(public authService: OidcSecurityService, public router: Router) {
    this.origin = this.getOrigin();
  }

  getOrigin(): string {    
    if ((location as any).href.toString().split('techfinance').length > 1) {
      return 'techfinance';
    }
    return 'empreenderdinheiro';
  }


  ngOnInit() { }

  toggleSideBar() {
    this.toggleSideBarForMe.emit();
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 300);
  }
  logout() {
    this.authService.logoff();
  }
}
